<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<div class="fm-title"><a id="page_4"><b>Contents</b></a></div><a id="page_4">
</a><div class="toc1"><a id="page_4"></a><a href="#/06_Preface"><b>Preface</b></a></div>
<div class="toc1"><a href="#/07_Acknowledgments"><b>Acknowledgments</b></a></div>
<div class="toc1"><a href="#/08_Keeping_It_Real"><b>Keeping It Real</b></a></div>
<div class="toc1"><a href="#/09_Part01"><b>Section I: The Mind</b></a></div>
<div class="toc2"><a href="#/10_Chapter01">1. Mindfulness</a></div>
<div class="toc2"><span href="#/11_Chapter02" title="Link target outside of Sample">2. Positive Psychology</span></div>
<div class="toc1"><span href="#/12_Part02" title="Link target outside of Sample"><b>Section II: The Body</b></span></div>
<div class="toc2"><span href="#/13_Chapter03" title="Link target outside of Sample">3. Mindful Fuel</span></div>
<div class="toc2"><span href="#/14_Chapter04" title="Link target outside of Sample">4. Pro-Active</span></div>
<div class="toc2"><span href="#/15_Chapter05" title="Link target outside of Sample">5. Sleep</span></div>
<div class="toc2"><span href="#/16_Chapter06" title="Link target outside of Sample">6. Your Network Is Your Net Worth</span></div>
<div class="toc2"><span href="#/17_Chapter07" title="Link target outside of Sample">7. Tune Into Intuition</span></div>
<div class="toc2"><span href="#/18_Chapter08" title="Link target outside of Sample">8. On Fertile Ground</span></div>
<div class="toc1"><span href="#/19_Part03" title="Link target outside of Sample"><b>Section III: The Spirit</b></span></div>
<div class="toc2"><span href="#/20_Chapter09" title="Link target outside of Sample">9. The Spirit Trip</span></div>
<div class="toc2"><span href="#/21_Chapter10" title="Link target outside of Sample">10. The Soul’s Journey</span></div>
<div class="toc2"><span href="#/22_Chapter11" title="Link target outside of Sample">11. You Gotta Have Faith</span></div>
<div class="toc2"><span href="#/23_Chapter12" title="Link target outside of Sample">12. The Ebb and Flow</span></div>
<div class="toc2"><span href="#/24_Chapter13" title="Link target outside of Sample">13. Musically Inclined</span></div>
<div class="toc2"><span href="#/25_Chapter14" title="Link target outside of Sample">14. Chasing the High</span></div>
<div class="toc2"><a id="page_5"></a><span href="#/26_Chapter15" title="Link target outside of Sample">15. On Being a Unicorn</span></div>
<div class="toc2"><span href="#/27_Chapter16" title="Link target outside of Sample">16. The Mind Says Unicorn, the Body Says P(h)ony</span></div>
<div class="toc2"><span href="#/28_Chapter17" title="Link target outside of Sample">17. On Purpose</span></div>
<div class="toc2"><span href="#/29_Chapter18" title="Link target outside of Sample">18. Love Connection</span></div>
<div class="toc2"><span href="#/30_Chapter19" title="Link target outside of Sample">19. The Power of Love</span></div>
<div class="toc2"><span href="#/31_Chapter20" title="Link target outside of Sample">20. Rocky Terrain</span></div>
<div class="toc2"><span href="#/32_Chapter21" title="Link target outside of Sample">21. Growing Pains</span></div>
<div class="toc2"><span href="#/33_Chapter22" title="Link target outside of Sample">22. Seeing the Light</span></div>
<div class="toc2"><span href="#/34_Chapter23" title="Link target outside of Sample">23. Getting Served</span></div>
<div class="toc1"><span href="#/35_A_Final_Thought" title="Link target outside of Sample"><b>A Final Thought: We Found Love in a Hopeful Place</b></span></div>
<div class="toc1"><span href="#/36_Appendix" title="Link target outside of Sample"><b>Appendix: Pax’s Stalwart Smoothie Recipe</b></span></div>
<div class="toc1"><span href="#/37_Endnotes" title="Link target outside of Sample"><b>Endnotes</b></span></div>
<div class="toc1"><span href="#/38_Bibliography" title="Link target outside of Sample"><b>Bibliography</b></span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?460689e5